/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Feature2Inputs */

const ja_playdata_pricing_feature2 = /** @type {(inputs: Playdata_Pricing_Feature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日程別視聴者数の推移`)
};

const en_playdata_pricing_feature2 = /** @type {(inputs: Playdata_Pricing_Feature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes in viewership by event stage`)
};

/**
* | output |
* | --- |
* | "Changes in viewership by event stage" |
*
* @param {Playdata_Pricing_Feature2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_feature2 = /** @type {((inputs?: Playdata_Pricing_Feature2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Feature2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_feature2(inputs)
	return en_playdata_pricing_feature2(inputs)
});